<template>
  <div class="amount-panel-container">
    <CellGroup>
      <Cell title="配送费用" :value="'¥' + data.freight" />
      <Cell title="优惠总额" :value="'-¥' + data.upperApportionTotal" />
      <Cell title="商品总额" :value="'¥' + data.dealAmountTotal" />
      <Cell title="开票总额" :value="'¥' + data.tax" />
      <Cell
        title="订单总额"
        :value="'¥' + data.actualPayAmount"
        value-class="text-red"
      />
    </CellGroup>
  </div>
</template>

<script>
import { Cell, CellGroup } from "vant";

export default {
  components: { Cell, CellGroup },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="less" scoped>
.amount-panel-container {
  margin: 28px 0 198px 0;

  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
  border-radius: 12px;
  padding: 32px 28px;
}
</style>